import { render } from "./serviceWrapper.vue?vue&type=template&id=6c0312f3"
import script from "./serviceWrapper.vue?vue&type=script&lang=js"
export * from "./serviceWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__